import { Check, Sparkles, Crown, Zap, TrendingUp, Users, BarChart3, FileText, Camera, Bell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const premiumFeatures = [
  {
    icon: Sparkles,
    title: "AI Workout Analysis",
    description: "Get AI-powered insights and recommendations for your workouts",
    gradient: "from-purple-500 to-pink-500"
  },
  {
    icon: TrendingUp,
    title: "Advanced Analytics",
    description: "Detailed performance metrics and progress tracking",
    gradient: "from-blue-500 to-cyan-500"
  },
  {
    icon: FileText,
    title: "AI Template Generation",
    description: "Generate personalized workout templates with AI",
    gradient: "from-green-500 to-emerald-500"
  },
  {
    icon: Camera,
    title: "Body Assessment Analysis",
    description: "AI-powered physique analysis and recommendations",
    gradient: "from-orange-500 to-red-500"
  },
  {
    icon: BarChart3,
    title: "Extended History",
    description: "Access unlimited workout history and data",
    gradient: "from-indigo-500 to-purple-500"
  },
  {
    icon: Users,
    title: "Priority Support",
    description: "Get faster responses and dedicated support",
    gradient: "from-pink-500 to-rose-500"
  },
  {
    icon: Bell,
    title: "Enhanced Notifications",
    description: "Advanced notification preferences and alerts",
    gradient: "from-yellow-500 to-amber-500"
  },
  {
    icon: Crown,
    title: "Premium Badge",
    description: "Show off your premium status in the community",
    gradient: "from-yellow-400 to-amber-500"
  },
];

export const PremiumFeaturesList = () => {
  return (
    <div className="space-y-4 py-4">
      <div className="text-center mb-6">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-yellow-400 to-amber-500 text-white mb-4">
          <Crown className="w-5 h-5" />
          <span className="font-bold">Premium Features Unlocked</span>
        </div>
        <p className="text-muted-foreground">You now have access to all premium features!</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {premiumFeatures.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <Card
              key={index}
              className="border-2 border-primary/20 hover:border-primary/40 transition-all hover:shadow-glow"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardContent className="p-4">
                <div className="flex items-start gap-3">
                  <div className={`p-2 rounded-lg bg-gradient-to-br ${feature.gradient} flex-shrink-0`}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="font-semibold text-sm">{feature.title}</h4>
                      <Check className="w-4 h-4 text-green-500 flex-shrink-0" />
                    </div>
                    <p className="text-xs text-muted-foreground">{feature.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="text-center pt-4">
        <p className="text-sm text-muted-foreground">
          Thank you for being a premium member! 🎉
        </p>
      </div>
    </div>
  );
};